export default "__VITE_ASSET__LnHvy1XB__"